'use client'

import { ReactNode } from 'react'
import { noop } from 'lodash'
import GoogleMapReact from 'google-map-react'

import { GoogleApiLoadedArgs } from '@marketplace-web/domain/google-maps-data'

type Props = {
  googleApiKey: string
  defaultZoom: number
  defaultCenter: GoogleMapReact.Coords
  children?: ReactNode
  mapOptions?: GoogleMapReact.MapOptions
  useGoogleInternalApi?: boolean
  onMapLoaded?: (map: google.maps.Map, maps: typeof google.maps) => void
  onMapClick?: (value: GoogleMapReact.ClickEventValue) => void
}

const GoogleMap = ({
  useGoogleInternalApi = false,
  onMapClick = noop,
  onMapLoaded = noop,
  googleApiKey,
  defaultZoom,
  defaultCenter,
  mapOptions,
  children,
}: Props) => {
  const handleGoogleApiLoaded = ({ map, maps }: GoogleApiLoadedArgs) => {
    if (useGoogleInternalApi) {
      onMapLoaded(map, maps)
    }
  }

  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: googleApiKey,
      }}
      defaultZoom={defaultZoom}
      defaultCenter={defaultCenter}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={handleGoogleApiLoaded}
      options={mapOptions}
      onClick={onMapClick}
    >
      {children}
    </GoogleMapReact>
  )
}

export default GoogleMap
